import { motion } from "framer-motion";
import { Star, ExternalLink } from "lucide-react";
import { REVIEWS, BUSINESS } from "@/data/site";

const Stars = () => (
  <div className="flex gap-0.5 text-[#C8A24A]">
    {[...Array(5)].map((_, i) => (
      <Star key={i} size={16} fill="currentColor" />
    ))}
  </div>
);

export const Reviews = () => {
  return (
    <section
      id="ressenyes"
      data-testid="reviews-section"
      className="scroll-target py-24 md:py-32 bg-[#FDFBF7]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div className="max-w-xl">
            <span className="text-sm uppercase tracking-[0.25em] font-semibold text-[#C8A24A]">
              Ressenyes
            </span>
            <h2 className="font-display text-4xl sm:text-5xl font-semibold text-[#8B0000] mt-4">
              El que diuen els clients
            </h2>
            <p className="mt-5 text-[#5C4A3D] text-lg leading-relaxed">
              Ens encanta veure clients contents. Si has gaudit dels nostres
              dolços, deixa'ns la teva ressenya a Google!
            </p>
          </div>
          <a
            data-testid="reviews-google-btn"
            href={BUSINESS.googleReviews}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-full border-2 border-[#8B0000] text-[#8B0000] px-7 py-3.5 font-semibold hover:bg-[#8B0000] hover:text-[#FDFBF7] transition-all whitespace-nowrap"
          >
            Deixa una ressenya <ExternalLink size={16} />
          </a>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {REVIEWS.map((r, i) => (
            <motion.div
              key={r.name}
              data-testid={`review-card-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
              className="bg-[#FAF5F0] p-7 rounded-2xl border border-[#2C1E16]/5 shadow-sm"
            >
              <Stars />
              <p className="mt-4 text-[#2C1E16] leading-relaxed">"{r.text}"</p>
              <div className="mt-5 flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-[#8B0000] text-[#FDFBF7] flex items-center justify-center font-display font-semibold">
                  {r.name.charAt(0)}
                </div>
                <div>
                  <p className="font-semibold text-[#2C1E16] text-sm">{r.name}</p>
                  <p className="text-xs text-[#5C4A3D]">Ressenya de Google</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
